import React, { useEffect, useState } from "react";
import { Card, List, Spin, message, Typography, Button, Table, Space } from "antd";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import API from "api/endpoints";
import axiosInstance from "api/axiosInstance";
import { DownloadOutlined } from "@ant-design/icons";

const { Title } = Typography;

const HiringDocumentsPage = () => {
  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState(null);
  const [downloading, setDownloading] = useState({}); // Track which files are being downloaded

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        setLoading(true);
        const employeeId = localStorage.getItem("personalId");

        if (!employeeId) {
          message.error("Employee ID not found in local storage");
          return;
        }

        const response = await axiosInstance.get(API.hiringContracts.getByEmployeeId(employeeId));

        const data = response.data;
        if(data){
             const documentList = [
        { name: "NDA File", file: data.ndafile },
        { name: "NCA File", file: data.ncafile },
        { name: "Employee Agreement", file: data.employeeAgreement },
        { name: "I-9 Form", file: data.i_nine },
        { name: "W-4 Form", file: data.w_four },
        { name: "Offer Letter", file: data.offerLetter },
        { name: "HR Policy", file: data.hrPolicy },
      ].filter((doc) => doc.file); // Only non-empty docs

      setDocuments(documentList);
        }
        else   {
          message.warning("No documents found.");
        }
      } catch (error) {
        console.error("Error fetching hiring documents:", error);
        message.error("Failed to fetch hiring documents");
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, []);

 // Handlers for View / Download
   // Base file URL (no /api at the end)
   const fileBaseUrl = process.env.REACT_APP_Base_URL;
 
   //  View document in new tab
   const handlePdfPreview = (fileUrl) => {
     if (!fileUrl) return message.warning("No file found");
 
     const cleanUrl = `${fileBaseUrl}/${fileUrl.replace(/^\/+/, "")}`;
 
     window.open(cleanUrl, "_blank");
   };
 
   //  Download document
   const handleDownload = (fileUrl, fileName) => {
     if (!fileUrl) {
       message.warning("No file to download");
       return;
     }
 
     try {
       // Directly trigger file download
       const link = document.createElement("a");
       link.href = fileUrl; // same URL used for preview
       link.setAttribute("download", fileName || "document");
       document.body.appendChild(link);
       link.click();
       document.body.removeChild(link);
       message.success(" Download started!");
     } catch (error) {
       console.error("Download failed:", error);
       message.error("Failed to download file");
     }
   };

 const documentColumns = [
  {
    title: "Document Name",
    dataIndex: "name",
    key: "name",
    align: "left", 
    onHeaderCell: () => ({
      style: { textAlign: "left", fontWeight: 600 },
    }),
    render: (text) => (
      <span style={{ fontWeight: 500 }}>{text}</span>
    ),
  },
  {
    title: "Actions",
    key: "actions",
    align: "center",
    width: 180, 
    onHeaderCell: () => ({
      style: { textAlign: "center", fontWeight: 600 },
    }),
    render: (_, record) => (
      <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
        <Button
          className="btn-back"
          size="small"
          onClick={() => handlePdfPreview(record.file)}
        >
          View
        </Button>

        <Button
          className="btn-primary"
          size="small"
          icon={<DownloadOutlined />}
          onClick={() => handleDownload(record.file, record.name)}
        >
          Download
        </Button>
      </div>
    ),
  },
];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card style={{ margin: 24 }}>
        <Title level={4}>Hiring Documents</Title>
        <p>Click the download button next to each document to save a copy.</p>

        {loading ? (
          <div style={{ textAlign: "center", marginTop: 40 }}>
            <Spin size="large" />
          </div>
        ) : documents ? (
         
          <Table 
           dataSource={documents}
           columns = { documentColumns}
           rowkey= "name"
           />
        ) : (
          <p>No HR documents available.</p>
        )}
      </Card>
    </DashboardLayout>
  );
};

export default HiringDocumentsPage;